import { supabase } from '@/lib/supabase';
import { Colleague } from '@/types/types';

export const colleagueService = {
  getAllColleagues: async (): Promise<Colleague[]> => {
    try {
      const { data, error } = await supabase
        .from('colleagues')
        .select('*')
        .order('id');

      if (error) throw error;
      return data as Colleague[];
    } catch (error) {
      console.error('Error fetching colleagues:', error);
      throw error;
    }
  }
};
